/**
 * Režim klienta. Určuje cestu k mapové stránce Mapio, která bude v mapové komponentě zobrazena.
 */
export enum ClientMode {
    /**
     * Standardní režim, napojení na embed-editor s Angularem.
     */
    EMBED_EDITOR = 'embed-editor',
    /**
     * @deprecated Zobrazení pro React Native, napojení na nového mobilního klienta.
     */
    REACT_NATIVE = 'new-client',
    /**
     * Zobrazení react mapy.
     */
    NEW_CLIENT = 'new-client',
    /**
     * Napojení na nového React klienta.
     */
    NEW_EDITOR = '',
}
